// extracted by mini-css-extract-plugin
module.exports = {"nav__locale":"NavLocale_nav__locale__5zZ59","nav__locale-buttons":"NavLocale_nav__locale-buttons__J54jH"};